import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
import lscache from "lscache";
import { formatarReal } from "../../../utils/formatar";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

let docDefinition = {};
let relatorio = {};
let NewPage = true;
let Line = 0;
let tipoAgenda;

const tableSeparador = [{ text: "", }, { text: "", }];

const inicializarRelatorio = () => {
  docDefinition = {
    pageOrientation: "portrait",
    pageSize: "A4",
    header: {},
    content: [],
    footer: [],
    styles: setStyles(),
    pageMargins: [40,80,40,25],
  };
}

export const createPDFDetalhesCalculadora = async (data, action = 'Open', setValue = null) => {

    inicializarRelatorio();

    cabecalhoRelatorio(data);
    tituloRelatorio(data);
    formatarAvisoImportante(data);
    formatarDadosGerais(data);
    
    if (Array.from(data.dadosProcessos).length > 0) {
      data.dadosProcessos.forEach(data => {
        lineSeparator();
        formatarDadosGerais(data)}
      );
    }

    formatarServicos(data);
    formatarNormasAplicacao(data);
    formatarNormasAplicacaoComum(data);
    rodapeRelatorio(data);

    const pdf = pdfMake.createPdf(docDefinition);

    if (action == 'Open') {
      pdf.open();
    }
    else if (action == 'Download'){
      pdf.download();
    }
    else if (action == 'Email') {
      pdf.getBase64( (data) => {
          setValue(data);
      });
    }
}

const lineSeparator = () => {
    docDefinition.content.push(  
        {canvas: [
            {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 535,
                y2: 5,
                lineWidth: 0.5,
                lineColor: "#BDBDBD",
            },
        ],
    });
}

const cabecalhoRelatorio = ( {pdfHeaderImage, dadosTerminal} ) => {
  
  const { DescTerminal,  Endereco,  Cep,  CidadeEstado,  Fone,  Cnpj,  Site } = dadosTerminal;

  // docDefinition.header = {
  //   image: pdfHeaderImage,
  //   width: 400,
  //   height: 45,
  //   margin: [45,20,0,0]
  // };

  docDefinition.header = {    
    margin: [40,20,0,0],
    columns : [
      {
        image: pdfHeaderImage,
        width: 120,
      },
      [
        { text: DescTerminal, style: 'header_items' , bold: true},
        { text: Endereco, style: 'header_items' },
        {
          style: 'header_items',
          columns: [
            { width: '33%', text: Cep},
            { width: '33%', text: CidadeEstado},          
            { width: '33%', text: Fone},                              
          ]
        },
        { text: Cnpj, style: 'header_items' },
        { text: Site, style: 'header_items', bold: true},
      ] 
    ]
  }

}

const tituloRelatorio = ( {Titulo} ) => {

  const header = [];

  header.push({
    text: Titulo,
    style: "header_center",
  });

  const lineHeader = { canvas: [{ type: "line", x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 0.5, },],};

  header.push(lineHeader);

  header.map(item => docDefinition.content.push(item));
}

const rodapeRelatorio = () => {

  docDefinition.footer = (currentPage, pageCount) => { 
    return [
      { text: currentPage.toString() + ' de ' + pageCount, style: 'footer', alignment: 'right' , margin:[0,0,45,10] },
      // { text: terminal, style: 'footer' , bold: true, margin: [45, 20, 0, 0]},
      // {
      //   style: 'footer',
      //   columns: [
      //     { width: '45%', text: endereco},
      //     { width: '15%', text: cep},
      //     { width: '15%', text: estado},          
      //     { width: '15%', text: fone},          
      //   ],
      //   columnGap: 10
      // },      
      // { text: cnpj, style: 'footer' },
      // {
      //   columns: [
      //     { text: site, style: 'footer', bold: true, margin: [45,0,0,10]},
      //     { text: currentPage.toString() + ' de ' + pageCount, style: 'footer', alignment: 'right' , margin:[0,0,45,10] },
      //   ],
      // }
    ]
  }

}

const formatarAvisoImportante = ({AvisoImportante}) => {

    docDefinition.content.push({
        text: AvisoImportante,
        style: "warning",
    });    

}

const formatarDadosGerais = ({ dadosLabel }) => {   

  const createColumns = (dados) => {  
    const colDadosGerais = {
      style: 'dadosGerais',
      columns: [],
      columnGap: 10
    }

    dados.map(async item => {
      colDadosGerais.columns.push({ 
          width: '33%',                
          text: [                    
            { text: `${item[0]}: `, bold: true },
            { text: item[1]  }, 
          ]
      });
    });

    return colDadosGerais;
  }

  const newArray = [];
  const divisor = 3;
  
  for (let i = 0; i <= Math.ceil( dadosLabel.length / divisor) * divisor; i = i + divisor) {
      const newValue = dadosLabel.slice(i, i + divisor);
      
      if (newValue.length) {
          const newColumn = createColumns(newValue);
          newArray.push(newColumn);
      }    
  }

  newArray.map(item => docDefinition.content.push(item));
  
}

const formatarServicos = ({ EhNacional, Servicos }) => {

    const totalGeral = Servicos.reduce((total, obj) => total + obj.Total, 0);
    const totalIss = Servicos.reduce((total, servico) => total + servico.ValorIss, 0);
    const totalPis = Servicos.reduce((total, servico) => total + servico.ValorPis, 0);
    const totalCofins = Servicos.reduce((total, servico) => total + servico.ValorCofins, 0);

    let totalImpostos = totalIss;
    if (EhNacional) {
        totalImpostos += totalPis;
        totalImpostos += totalCofins;
    }

    const contentServicos = {
        layout: 'lightHorizontalLines', 
        style: 'servicos',
        table: {
          headerRows: 1,
          widths: EhNacional ? 
            [ '8%', '8%', '32%', '12%', '4%', '13%', '6%', '8%', '9%' ] :
            [ '8%', '8%', '44%', '14%', '6%', '14%', '6%' ],
          body: [
            EhNacional ?
            [ 'Cod. Antaq', 'Cod. Tecon', 'Serviço', 'Valor Unitário', {text: 'Un.', alignment: "center"}, 'Valor Total', 'Iss', 'Pis', 'Cofins' ] :
            [ 'Cod. Antaq', 'Cod. Tecon', 'Serviço', 'Valor Unitário', {text: 'Un.', alignment: "center"}, 'Valor Total', 'ISS' ],
          ]
        }
    }

    Servicos.map(({ Servico, Valor, Iss, Pis, Cofins, Qtd, Total, CodGrupoServico, CodEstruturaServico }) => {
      EhNacional ?   
        contentServicos.table.body.push([
            CodGrupoServico,
            CodEstruturaServico,
            Servico, 
            formatarReal(Valor),
            {text: Qtd, alignment: "center"},
            formatarReal(Total),
            `${Iss}%`,
            `${Pis}%`,
            `${Cofins}%`,
        ])
      :
        contentServicos.table.body.push([
          CodGrupoServico,
          CodEstruturaServico,
          Servico, 
          formatarReal(Valor),
          {text: Qtd, alignment: "center"},
          formatarReal(Total),
          `${Iss}%`,
        ])
    });

    docDefinition.content.push(contentServicos);

    docDefinition.content.push({
        text: "Valor Total:",
        style: "header_Norma"
    });

    docDefinition.content.push({
        text: formatarReal(totalGeral),
        style: "totalGeral"
    }); 

    docDefinition.content.push({
        text: "Valor aprox. dos Trib. Fed., Estad. e Munic.:",
        style: "header_Norma"
    });

    docDefinition.content.push({
        text: formatarReal(totalImpostos),
        style: "totalGeral"
    }); 

}

const formatarNormasAplicacao = ({ItemsNormaAplicacao}) => {

    docDefinition.content.push({
        text: "Normas de Aplicação",
        style: "header_Norma"
    });

    docDefinition.content.push({
        canvas: [{ type: "line", x1: 180, y1: 0, x2: 350, y2: 0, lineWidth: 0.5, },]
    });

    const list = { ul: []};
    
    ItemsNormaAplicacao.map(({ DescNorma }) => {
      list.ul.push({
          text: DescNorma,
          style: "Norma_Aplicacao",
      })
    });

    docDefinition.content.push(list);
}

const formatarNormasAplicacaoComum = ({ItemsNormaAplicacaoComum}) => {

    const list = { ul: []};
      
    ItemsNormaAplicacaoComum.map(({ DescNorma }) => {
      list.ul.push({
          text: DescNorma,
          style: "Norma_Aplicacao",
      })
    });

    docDefinition.content.push(list);
}

const setStyles = () => {
  const styles = {
    header: {
      fontSize: 14,
      bold: true,
      margin: [5, 0, 0, 10],
    },
    header_center: {
      fontSize: 14,
      bold: true,
      // margin: [0, 30, 0, 5],
      margin: [0, 0, 0, 5],
      alignment: "center",
    },
    subheader_center: {
      fontSize: 10,
      bold: true,
      margin: [0, 0, 0, 10],
      alignment: "center",
    },
    subheader: {
      fontSize: 12,
      bold: true,
      margin: [5, 10, 0, 0],
    },
    topic: {
      fontSize: 10,
      bold: true,
      margin: [5, 10, 0, 5],
    },
    warning: {
      fontSize: 10,
      bold: true,
      margin: [5, 10, 0, 5],
      alignment: "justify",
    },
    footerText: {
      fontSize: 8,
      margin: [45, 10, 0, 5],
      alignment: "justify",
    },
    italic_note: {
      fontSize: 10,
      italics: true,
      margin: [100, 0, 100, 5],
      alignment: "center",
    },
    tableExample: {
      margin: [0, 5, 0, 15],
    },
    tableDetails: {
      margin: [0, 5, 0, 5],
      fontSize: 10,
      color: "black",
      lineHeight: 0.6,
    },
    tableHeader: {
      margin: [0, 5, 0, 5],
      fontSize: 10,
      color: "black",
    },
    dadosGerais: {
        fontSize: 10,
        margin: [5, 10, 0, 5]
    },    
    servicos: {
        fontSize: 10,
        margin: [5, 10, 0, 5]
    },
    header_Norma: {
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5],
        alignment: "center",
    },    
    Norma_Aplicacao: {
        fontSize: 10,
        margin: [5, 10, 0, 5],
        alignment: "justify",
    },
    totalGeral: {
        fontSize: 12,        
        alignment: "center",
        width: 200,
        margin: [0, 0, 0, 10],
        background: '#EBEBEB',
        borderRadius: '5px'
    },
    footer: {
      margin: [45, 0, 0, 0],
      alignment: "left",
      fontSize: 8,
    },   
    header_items: {
      margin: [10,0,0,0],
      alignment: "left",
      fontSize: 8
    }     
  };
  return styles;
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/Utils/pdfDetalhesCalculadora.js